/* Supported Phones page: search + brand tabs + list, *#06# Yes/No, FAQ. No dependencies. */
(function () {
  'use strict';
  var $ = function (root, sel) { return root.querySelector(sel); };
  var $$ = function (root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var LIMIT = 6;
  var TICK = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#157A4A" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  var CROSS = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#8A827A" stroke-width="2.6" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
  var CHEV = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
  var STRIP = { Samsung: 'Samsung ', Google: 'Google ' }; // shown without the brand word under their own heading

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function brandOf(name) { return /^iphone/i.test(name) ? 'Apple' : name.split(/\s+/)[0]; }

  // Parse "one phone per line"; "# Brand" lines set the brand for the lines under them.
  function parse(text) {
    var brands = [], byName = {}, forced = '';
    String(text || '').split(/\r?\n/).forEach(function (raw) {
      var line = raw.trim();
      if (!line) return;
      if (line.charAt(0) === '#') { forced = line.replace(/^#+/, '').trim(); return; }
      var b = forced || brandOf(line);
      var key = b.toLowerCase();
      if (!byName[key]) { byName[key] = { name: b, models: [] }; brands.push(byName[key]); }
      var strip = STRIP[byName[key].name];
      var show = strip && line.indexOf(strip) === 0 ? line.slice(strip.length) : line;
      byName[key].models.push({ full: line, show: show });
    });
    return brands;
  }
  function flat(text) {
    return String(text || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(function (x) { return x && x.charAt(0) !== '#'; });
  }

  function initFinder(el) {
    if (el.__fgs) return; el.__fgs = true;
    var cfg;
    try { cfg = JSON.parse($(el, '[data-ph-json]').textContent); } catch (e) { return; }
    var T = cfg.t || {};
    var brands = parse(cfg.supported);
    var unsup = flat(cfg.unsupported);
    var input = $(el, '[data-ph-q]'), clear = $(el, '[data-ph-clear]');
    var tabsEl = $(el, '[data-ph-tabs]'), results = $(el, '[data-ph-results]');
    var unsupWrap = $(el, '[data-ph-unsup-wrap]'), unsupList = $(el, '[data-ph-unsup]');
    var okBar = $(el, '[data-ph-ok]'), okText = $(el, '[data-ph-ok-text]'), noBar = $(el, '[data-ph-no]');
    var empty = $(el, '[data-ph-empty]'), emptyQ = $(el, '[data-ph-empty-q]');
    var mq = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };
    var state = { q: '', brand: null, open: {} };

    function hit(words, name) {
      var t = name.toLowerCase().split(/[\s()\/,+]+/).filter(Boolean);
      return words.every(function (w) { return t.some(function (x) { return x.indexOf(w) === 0; }); });
    }

    function render() {
      var q = state.q.trim().toLowerCase();
      var searching = q.length >= 2;
      var words = q.split(/\s+/).filter(Boolean);
      var per = brands.map(function (b) {
        return { name: b.name, models: searching ? b.models.filter(function (m) { return hit(words, m.full) || hit(words, m.show); }) : b.models };
      });
      var matchTotal = per.reduce(function (n, p) { return n + p.models.length; }, 0);
      var sel = state.brand === null ? (searching ? -1 : 0) : state.brand;
      if (sel >= 0 && (!per[sel] || (searching && !per[sel].models.length))) sel = -1;

      // Tabs
      var tabs = [{ i: -1, name: T.all || 'All', count: matchTotal }].concat(per.map(function (p, i) { return { i: i, name: p.name, count: p.models.length }; }));
      tabsEl.innerHTML = tabs.map(function (t) {
        var on = t.i === sel, off = t.count === 0 && t.i !== -1;
        return '<button type="button" role="tab" class="fgs-ph-tab" data-i="' + t.i + '" aria-selected="' + on + '"' + (off ? ' disabled' : '') + '>' + esc(t.name) + '<span>' + t.count + '</span></button>';
      }).join('');

      // Groups
      var groups = sel === -1
        ? per.filter(function (p) { return p.models.length; }).map(function (p) { return { name: p.name, models: p.models, head: true }; })
        : [{ name: per[sel].name, models: per[sel].models, head: false }];
      results.innerHTML = groups.map(function (g) {
        var n = g.models.length, shown = Math.min(state.open[g.name] || LIMIT, n);
        var more = shown < n, less = n > LIMIT && shown >= n;
        var label = mq.matches ? (T.more || 'Show more') : String(T.all_n || 'Show all [n] [brand] phones').replace('[n]', n).replace('[brand]', g.name === 'Apple' ? 'Apple' : g.name);
        return '<div class="fgs-ph-group">' +
          (g.head ? '<div class="fgs-ph-group__head"><h2 class="fgs-ph-group__name fgs-ph__hd">' + esc(g.name) + '</h2><span class="fgs-ph-group__count">' + n + ' ' + esc(n === 1 ? (T.phone || 'phone') : (T.phones || 'phones')) + '</span></div>' : '') +
          '<ul class="fgs-ph-list">' + g.models.slice(0, shown).map(function (m) { return '<li>' + TICK + '<span>' + esc(m.show) + '</span></li>'; }).join('') + '</ul>' +
          (more ? '<button type="button" class="fgs-ph-more" data-more="' + esc(g.name) + '" data-n="' + n + '">' + esc(label) + CHEV + '</button>' : '') +
          (less ? '<button type="button" class="fgs-ph-more fgs-ph-more--less" data-less="' + esc(g.name) + '">' + esc(T.fewer || 'Show fewer') + CHEV + '</button>' : '') +
          '</div>';
      }).join('');

      // Phones without eSIM, and the result bars
      var noRows = searching ? unsup.filter(function (m) { return hit(words, m); }) : [];
      unsupList.innerHTML = noRows.map(function (m) { return '<li>' + CROSS + '<span>' + esc(m) + '</span></li>'; }).join('');
      unsupWrap.hidden = !noRows.length;
      var okCount = searching ? matchTotal : 0;
      okBar.hidden = !(okCount > 0 && okCount <= 6);
      okText.textContent = okCount === 1 ? (T.okOne || '1 matching phone supports eSIM') : String(T.okMany || '[n] matching phones support eSIM').replace('[n]', okCount);
      noBar.hidden = !(searching && okCount === 0 && noRows.length > 0);
      empty.hidden = !(q.length >= 3 && okCount === 0 && noRows.length === 0);
      emptyQ.textContent = state.q.trim();
      clear.hidden = !state.q.length;
    }

    input.addEventListener('input', function () { state.q = input.value; state.brand = null; state.open = {}; render(); });
    clear.addEventListener('click', function () { input.value = ''; state.q = ''; state.brand = null; state.open = {}; render(); input.focus(); });
    tabsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-i]'); if (!b || b.disabled) return;
      state.brand = parseInt(b.getAttribute('data-i'), 10); state.open = {}; render();
    });
    results.addEventListener('click', function (e) {
      var m = e.target.closest('[data-more]'), l = e.target.closest('[data-less]');
      if (m) { var k = m.getAttribute('data-more'), n = parseInt(m.getAttribute('data-n'), 10); state.open[k] = mq.matches ? (state.open[k] || LIMIT) + LIMIT : n; render(); }
      if (l) { delete state.open[l.getAttribute('data-less')]; render(); }
    });
    if (mq.addEventListener) mq.addEventListener('change', render);

    // Typing examples in the search box
    var words = String(cfg.placeholders || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (!words.length) words = ['iPhone 17'];
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) input.placeholder = (T.eg || 'e.g.') + ' ' + words[0];
    else {
      var w = 0, i = 0, del = false;
      (function tick() {
        var word = words[w];
        if (!del) { i++; input.placeholder = word.slice(0, i); if (i === word.length) { del = true; return setTimeout(tick, 1400); } return setTimeout(tick, 90); }
        i--; input.placeholder = word.slice(0, i); if (i === 0) { del = false; w = (w + 1) % words.length; return setTimeout(tick, 350); } setTimeout(tick, 40);
      })();
    }
    render();
  }

  function initCheck(el) {
    if (el.__fgs) return; el.__fgs = true;
    var state = '';
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ph-eid]'); if (!b) return;
      var v = b.getAttribute('data-ph-eid');
      state = state === v ? '' : v;
      $$(el, '[data-ph-eid]').forEach(function (x) { x.setAttribute('aria-pressed', String(x.getAttribute('data-ph-eid') === state)); });
      $$(el, '[data-ph-eid-show]').forEach(function (x) { x.hidden = x.getAttribute('data-ph-eid-show') !== state; });
    });
  }

  function initFaq(el) {
    if (el.__fgs) return; el.__fgs = true;
    el.addEventListener('click', function (e) {
      var b = e.target.closest('.fgs-ph-faq__q'); if (!b) return;
      var open = b.getAttribute('aria-expanded') === 'true';
      $$(el, '.fgs-ph-faq__q').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = true; });
      if (!open) { b.setAttribute('aria-expanded', 'true'); var p = document.getElementById(b.getAttribute('aria-controls')); if (p) p.hidden = false; }
    });
  }

  // Links to the *#06# check ("Click here", "Check with *#06#", "Dial *#06# to check") scroll smoothly to it.
  if (!window.__fgsPhJump) {
    window.__fgsPhJump = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#fgs-eid"]'); if (!a) return;
      var t = document.getElementById('fgs-eid'); if (!t) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#fgs-eid');
    });
  }

  function boot() {
    $$(document, '[data-fgs-phones]').forEach(initFinder);
    $$(document, '[data-fgs-phones-check]').forEach(initCheck);
    $$(document, '[data-fgs-phones-faq]').forEach(initFaq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
